/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface InterpretingServiceDTO {
  serviceId: number;
  serviceName: string;
  rateId: number;
  rateName: string;
  priceLow: number | null;
  priceHigh: number | null;
}
const InterpretingServiceDTO = {
  create: (initValues?: Partial<InterpretingServiceDTO> | null): InterpretingServiceDTO => {
    const defaults: InterpretingServiceDTO = {
      serviceId: 0,
      serviceName: "",
      rateId: 0,
      rateName: "",
      priceLow: null,
      priceHigh: null,
    };
    const fixedValues: Partial<InterpretingServiceDTO> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default InterpretingServiceDTO;
